<div class="recover-password-email-sent">
  <div class="recover-password-email-sent__description">{{ 'login.recovery.password-email-sent.description' | translate }}</div>

  @if (passwordRecoveryCredentials(); as passwordRecoveryCredentials) {
    <div class="recover-password-email-sent__content">
      <div class="recover-password-email-sent__tooltip-wrapper">
        <itc-table-tooltip tooltipPosition="top-left" [tooltipText]="passwordRecoveryCredentials.username">
          <span class="recover-password-email-sent__username">{{ passwordRecoveryCredentials.username }}</span>
        </itc-table-tooltip>
      </div>

      <div class="recover-password-email-sent__tooltip-wrapper">
        <itc-table-tooltip tooltipPosition="top-left" [tooltipText]="passwordRecoveryCredentials.companyName">
          <span class="recover-password-email-sent__company-name">{{ passwordRecoveryCredentials.companyName }}</span>
        </itc-table-tooltip>
      </div>
    </div>
  }
</div>
